import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const reportButton = style({
  marginTop: vars.space.s,
  border: 0,
  borderRadius: vars.space["2xl"],
  backgroundColor: "#37003c",
  // hardcoded colours because our error boundary sits at the top layer outside of the theme
  cursor: "pointer",
  padding: vars.space.s,
  color: "white",
});
